// ── CONSTANTS ──
export const COSTOS_FIJOS = [
  'DT Farmaceutica', 'Matricula Farmaceutica', 'Sistema GEMA',
  'Alquiler', 'Luz', 'Internet', 'Monotributo',
  'Amortizaciones', 'Impuesto municipal', 'Contadora'
];
export const SOCIOS = ['Sol', 'Bauti', 'Andy'];
export const COLORS_SOCIOS = { Sol: '#1A6B45', Bauti: '#1A4E76', Andy: '#8B4513' };
export const USER_COLORS = ['#259656','#1A4E76','#8B4513','#6C3483','#B03A2E','#0E6655'];

// ── FORMATTERS ──
export function fmtM(n) {
  const num = parseFloat(n) || 0;
  return (num < 0 ? '-' : '') + '$' + Math.abs(num).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function todayStr() {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

export function fmtDate(iso) {
  if (!iso) return '';
  const p = iso.split('-');
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : iso;
}

export function fmtDateShort(iso) {
  if (!iso) return '';
  const p = iso.split('-');
  return p.length === 3 ? `${p[2]}/${p[1]}` : iso;
}

export function ini(name) {
  return (name || '?').split(' ').map(w => w[0] || '').join('').toUpperCase().slice(0, 2);
}

export function hashPass(pass) {
  let h = 0;
  for (let i = 0; i < pass.length; i++) { h = ((h << 5) - h) + pass.charCodeAt(i); h = h & h; }
  return h.toString(36);
}

// ── CAJA CALCULATIONS ──
export function calcCaja(movimientos) {
  let ef = 0, cuentas = 0;
  const EXCLUIR = ['ajuste_stock'];
  Object.values(movimientos || {}).forEach(m => {
    if (EXCLUIR.includes(m.tipo)) return;
    const s = m.signo === '+' ? 1 : -1;
    // Si el movimiento tiene desglose por medio (ventas mixtas), usarlo directamente
    if (m.monto_efectivo !== undefined || m.monto_transferencia !== undefined || m.monto_qr !== undefined) {
      ef += s * (parseFloat(m.monto_efectivo) || 0);
      cuentas += s * (parseFloat(m.monto_transferencia) || 0);
      cuentas += s * ((parseFloat(m.monto_qr) || 0) * 0.99); // 1% comisión QR
    } else {
      const monto = parseFloat(m.monto) || 0;
      if (m.medio === 'efectivo') ef += s * monto;
      else if (m.medio === 'qr') cuentas += s * (monto * 0.99);
      else cuentas += s * monto;
    }
  });
  return { ef, cuentas, total: ef + cuentas };
}

// ── VENTAS ──
export function ventasPorDia(movimientos) {
  const dias = {};
  Object.values(movimientos || {}).filter(m => m.tipo === 'venta').forEach(m => {
    if (m.fecha) dias[m.fecha] = (dias[m.fecha] || 0) + (parseFloat(m.monto) || 0);
  });
  return dias;
}

export function promedioDiario(movimientos, dias = 20) {
  const porDia = ventasPorDia(movimientos);
  const sorted = Object.entries(porDia).sort((a, b) => b[0].localeCompare(a[0])).slice(0, dias);
  if (!sorted.length) return 0;
  return sorted.reduce((a, [, v]) => a + v, 0) / sorted.length;
}

export function ventasHoy(movimientos) {
  const hoy = todayStr();
  return Object.values(movimientos || {}).filter(m => m.tipo === 'venta' && m.fecha === hoy).reduce((a, m) => a + (parseFloat(m.monto) || 0), 0);
}

export function ventasMes(movimientos, mes) {
  const m = mes || todayStr().slice(0, 7);
  return Object.values(movimientos || {}).filter(mv => mv.tipo === 'venta' && mv.fecha?.slice(0, 7) === m).reduce((a, mv) => a + (parseFloat(mv.monto) || 0), 0);
}

// ── STOCK ──
export function calcVariacionStock(movimientos, compras, margen) {
  const m = margen !== undefined ? margen : 0.34;
  const cmvPct = 1 - m;
  const totalVentas = Object.values(movimientos || {}).filter(mv => mv.tipo === 'venta').reduce((a, mv) => a + (parseFloat(mv.monto) || 0), 0);
  const cmv = totalVentas * cmvPct;
  const totalCompras = Object.values(compras || {}).reduce((a, c) => a + (parseFloat(c.monto) || 0), 0);
  // Aplicar ajustes de stock (reestablecimientos)
  const ajustes = Object.values(movimientos || {}).filter(mv => mv.tipo === 'ajuste_stock').reduce((a, mv) => {
    return a + (parseFloat(mv.monto) || 0) * (mv.signo === '-' ? -1 : 1);
  }, 0);
  const variacion = totalCompras - cmv + ajustes;
  return { compras: totalCompras, cmv, cmvPct, variacion };
}

// Stats por proveedor
export function statsProveedores(compras, movimientos) {
  const stats = {};
  // From compras a cuenta
  Object.values(compras || {}).forEach(c => {
    const nombre = c.proveedor || 'Sin nombre';
    if (!stats[nombre]) stats[nombre] = { nombre, montoCompras: 0, cantCompras: 0, montoPagado: 0 };
    stats[nombre].montoCompras += parseFloat(c.monto) || 0;
    stats[nombre].cantCompras += 1;
    if (c.pagado) stats[nombre].montoPagado += parseFloat(c.monto) || 0;
  });
  // From movimientos de compra contado y pago proveedor
  Object.values(movimientos || {}).filter(m => m.tipo === 'compra' && m.proveedor).forEach(m => {
    const nombre = m.proveedor;
    if (!stats[nombre]) stats[nombre] = { nombre, montoCompras: 0, cantCompras: 0, montoPagado: 0 };
    stats[nombre].montoCompras += parseFloat(m.monto) || 0;
    stats[nombre].cantCompras += 1;
    stats[nombre].montoPagado += parseFloat(m.monto) || 0;
  });
  const total = Object.values(stats).reduce((a, s) => a + s.montoCompras, 0);
  return Object.values(stats).map(s => ({ ...s, pct: total > 0 ? (s.montoCompras / total) * 100 : 0 })).sort((a, b) => b.montoCompras - a.montoCompras);
}

// ── FLUJO DE FONDOS (miercoles a miercoles) ──
export function getFlujoBounds(offsetWeeks = 0) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const day = today.getDay();
  // Days until next Wednesday (day 3)
  const daysUntilWed = day <= 3 ? 3 - day : 10 - day;
  const nextWed = new Date(today.getTime() + (daysUntilWed + offsetWeeks * 7) * 86400000);
  // Thursday after the Wednesday
  const nextThu = new Date(nextWed.getTime() + 1 * 86400000);
  const fmt = d => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  return {
    desde: fmt(today),
    hasta: fmt(nextWed),
    hastaConJueves: fmt(nextThu),
    nextWed, nextThu, daysUntilWed,
    daysUntilThu: daysUntilWed + 1,
  };
}

export function calcFlujo(movimientos, compras, costosMes, ajusteSeguridad = 0) {
  const caja = calcCaja(movimientos);
  const prom = promedioDiario(movimientos, 20);
  const bounds = getFlujoBounds(0);
  const hoy = todayStr();
  // Solo días que faltan desde mañana hasta el miércoles (no incluir hoy ni días pasados)
  const today = new Date(); today.setHours(0,0,0,0);
  const wed = new Date(bounds.hastaConJueves); wed.setHours(0,0,0,0);
  const diasRestantes = Math.max(0, Math.ceil((wed - today) / 86400000));
  const promAjustado = Math.max(0, prom - ajusteSeguridad);
  const ingresoProyectado = diasRestantes * promAjustado;
  const totalProyectado = caja.total + ingresoProyectado;

  // Pagos: compras a cuenta con vencimiento hasta el jueves inclusive
  const pagosCompras = Object.values(compras || {})
    .filter(c => !c.pagado && c.fechaVenc && c.fechaVenc >= hoy && c.fechaVenc <= bounds.hastaConJueves)
    .reduce((a, c) => a + (parseFloat(c.monto) || 0), 0);

  // Pagos: costos fijos con fecha de pago hasta el jueves inclusive
  const pagosCostos = Object.values(costosMes || {})
    .filter(c => c.fecha && c.fecha >= hoy && c.fecha <= bounds.hastaConJueves && !c.esAmortizacion)
    .reduce((a, c) => a + (parseFloat(c.monto) || 0), 0);

  const pagosEnPeriodo = pagosCompras + pagosCostos;
  const solvencia = totalProyectado - pagosEnPeriodo;

  return {
    caja: caja.total, diasRestantes, prom, promAjustado,
    ingresoProyectado, totalProyectado,
    pagosCompras, pagosCostos, pagosEnPeriodo,
    solvencia, bounds
  };
}

// ── COSTOS ──
export function totalCostosFijos(costosMes, incluirAmort = false) {
  return Object.values(costosMes || {}).filter(c => incluirAmort || c.nombre !== 'Amortizaciones').reduce((a, c) => a + (parseFloat(c.monto) || 0), 0);
}

// Retorna costos totales de un mes dado YYYY-MM desde movimientos históricos (pago_proveedor)
export function costosDeHistorial(movimientos, mesStr) {
  return Object.values(movimientos || {})
    .filter(m => m.tipo === 'pago_proveedor' && m.fecha?.slice(0, 7) === mesStr)
    .reduce((a, m) => a + (parseFloat(m.monto) || 0), 0);
}

// Prorratear costos de una semana (desde → hasta) usando días reales por mes
// costosMes: costos del mes actual; movimientos: para buscar históricos
export function costosProrrateadosSemana(costosMes, desde, hasta, movimientos) {
  // Si no se pasan desde/hasta, usar el mes actual dividido 4.33 (compatibilidad)
  if (!desde || !hasta) return totalCostosFijos(costosMes, false) / 4.33;

  const diasEnMes = (y, m) => new Date(y, m, 0).getDate();

  // Agrupar días de la semana por mes
  const diasPorMes = {};
  const d = new Date(desde);
  const fin = new Date(hasta);
  while (d <= fin) {
    const mesKey = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    diasPorMes[mesKey] = (diasPorMes[mesKey] || 0) + 1;
    d.setDate(d.getDate() + 1);
  }

  const mesActual = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0');

  let total = 0;
  for (const [mesKey, dias] of Object.entries(diasPorMes)) {
    const [y, m] = mesKey.split('-').map(Number);
    const totalDiasMes = diasEnMes(y, m);

    // Obtener costos del mes: si es el actual usar costosMes, si es histórico usar movimientos
    let costosMesTotal;
    if (mesKey === mesActual) {
      costosMesTotal = totalCostosFijos(costosMes, false);
    } else {
      costosMesTotal = movimientos ? costosDeHistorial(movimientos, mesKey) : 0;
      // Si no hay datos históricos, usar costosMes como estimación
      if (!costosMesTotal) costosMesTotal = totalCostosFijos(costosMes, false);
    }

    total += (costosMesTotal / totalDiasMes) * dias;
  }

  return total;
}


// ── GANANCIAS SEMANALES (lunes a domingo) ──
export function getSemanaBounds(offsetWeeks = 0) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  const lunes = new Date(d.getTime() + (diff + offsetWeeks * 7) * 86400000);
  const domingo = new Date(lunes.getTime() + 6 * 86400000);
  const fmt = dd => dd.getFullYear() + '-' + String(dd.getMonth() + 1).padStart(2, '0') + '-' + String(dd.getDate()).padStart(2, '0');
  return { desde: fmt(lunes), hasta: fmt(domingo), key: fmt(lunes) };
}

export function calcGananciaSemana(movimientos, costosMes, desde, hasta) {
  const ventas = Object.values(movimientos || {}).filter(m => m.tipo === 'venta' && m.fecha >= desde && m.fecha <= hasta).reduce((a, m) => a + (parseFloat(m.monto) || 0), 0);
  const gastosVar = Object.values(movimientos || {}).filter(m => m.tipo === 'gasto' && m.fecha >= desde && m.fecha <= hasta).reduce((a, m) => a + (parseFloat(m.monto) || 0), 0);
  const ganBruta = ventas * 0.34;
  const costoProrr = costosProrrateadosSemana(costosMes, desde, hasta, movimientos);
  const ganNeta = ganBruta - costoProrr - gastosVar;
  return { ventas, ganBruta, costoProrr, gastosVar, ganNeta };
}

export function calcAjusteSemana(semAnterior, movimientos, costosMes) {
  if (!semAnterior?.cerrada) return { total: 0, porSocio: {} };
  const real = calcGananciaSemana(movimientos, costosMes, semAnterior.bounds.desde, semAnterior.bounds.hasta);
  const distTotal = Object.values(semAnterior.dist || {}).reduce((a, b) => a + b, 0);
  const diff = real.ganNeta - distTotal;
  const socioNames = Object.keys(semAnterior.dist || {});
  const porSocio = {};
  socioNames.forEach(n => {
    const prop = distTotal > 0 ? (semAnterior.dist[n] || 0) / distTotal : 1 / socioNames.length;
    porSocio[n] = diff * prop;
  });
  return { total: diff, porSocio, ganNetaReal: real.ganNeta, distTotal };
}

export function calcEstadisticaProveedores(compras, movimientos) {
  const stats = {};
  Object.values(compras || {}).forEach(c => {
    if (!c.proveedor) return;
    const key = c.proveedor.toUpperCase().trim();
    if (!stats[key]) stats[key] = { nombre: c.proveedor, total: 0, count: 0 };
    stats[key].total += parseFloat(c.monto) || 0;
    stats[key].count += 1;
  });
  Object.values(movimientos || {}).forEach(m => {
    if (m.tipo !== 'compra' && m.tipo !== 'pago_proveedor') return;
    if (!m.proveedor) return;
    const key = m.proveedor.toUpperCase().trim();
    if (!stats[key]) stats[key] = { nombre: m.proveedor, total: 0, count: 0 };
    stats[key].total += parseFloat(m.monto) || 0;
    stats[key].count += 1;
  });
  const list = Object.values(stats).sort((a, b) => b.total - a.total);
  const grandTotal = list.reduce((a, s) => a + s.total, 0);
  return list.map(s => ({ ...s, pct: grandTotal > 0 ? (s.total / grandTotal) * 100 : 0 }));
}

// ── GCAL URL ──
export function gcalUrl(title, date, details = '') {
  if (!date) return '';
  const d = date.replace(/-/g, '');
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${d}/${d}&details=${encodeURIComponent(details)}`;
}

// ── EXPORT TO CSV ──
export function exportToCSV(filename, headers, rows) {
  const csvHeaders = headers.join(',');
  const csvRows = rows.map(row =>
    row.map(cell => {
      const v = cell === null || cell === undefined ? '' : cell;
      const s = String(v).replace(/"/g, '""');
      return s.includes(',') || s.includes('\n') || s.includes('"') ? `"${s}"` : s;
    }).join(',')
  );
  const csv = [csvHeaders, ...csvRows].join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
